let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6A7am")).then(() => parcelRequire('duJA4'));